module.exports = __webpack_public_path__ + "img/robot.8702aa98.webp";